import { ImpactRating } from "~/components/impact/Updated/impact-updated";
import { ScoreRating } from "~/operations";
import { Score } from "~/lib/types";
import { useTheme } from "@mui/material";

export function getImpactLabelUpdated(
  rating: ImpactRating["rating"],
): ScoreRating {
  let normalizedRating = rating?.toLowerCase();

  if (normalizedRating === "none") {
    return ScoreRating.None;
  } else if (normalizedRating === "low") {
    return ScoreRating.Low;
  } else if (normalizedRating === "medium") {
    return ScoreRating.Medium;
  } else if (normalizedRating === "high") {
    return ScoreRating.High;
  } else if (normalizedRating === "unscored") {
    return ScoreRating.Unscored;
  } else if (normalizedRating === "error") {
    return ScoreRating.Error;
  } else {
    return ScoreRating.Critical;
  }
}

export function adjustImpactColor({
  color,
  score,
  isInactive,
}: {
  color: string;
  isInactive: boolean;
  score?: Score;
}) {
  const theme = useTheme();

  // If the check is ignored or disabled
  if (isInactive) {
    return theme.palette.unknown.main;
  }

  if (score) {
    // Check Error
    if (score.type === 4) {
      return theme.palette.error.main;
    }

    // Check Passed
    if (score.value === 100) {
      return theme.palette.none.main;
    }
  }

  return color;
}
